import { render, staticRenderFns } from "./physicalExamination.vue?vue&type=template&id=a178f622"
import script from "./physicalExamination.vue?vue&type=script&lang=js"
export * from "./physicalExamination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports